import { SxProps, Theme } from '@mui/material';
import Paper from '@mui/material/Paper';
import { FC, ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  className?: string;
  elevation?: number;
  sx?: SxProps<Theme>;
  id?: string;
}

export const PaperLayout: FC<IProps> = ({
  className,
  children,
  elevation = 0,
  sx,
  id,
  ...props
}) => (
  <Paper
    id={id}
    elevation={elevation}
    sx={sx}
    className={className}
    data-testid="paper-layout"
    {...props}
  >
    {children}
  </Paper>
);
